import SwipeableFormDrawer from "components/SwipeableFormDrawer";
import UpdateUserPasswordForm from "./form";

export default function UpdateUserPassword() {
    return (
        <SwipeableFormDrawer>
            <UpdateUserPasswordForm />
        </SwipeableFormDrawer>
    )
}